<template>
  <v-flex>
    <v-card color="#061a19" class="rounded mx-2">
      <v-card-text class="text-xs-center" style="padding: 4px">
        <div>
          <span class="white--text">Give someone a </span>
          <span class="white--text font-weight-medium">
            reason to smile today</span
          >
          <span class="ml-2 mr-2">&#129395;</span>
          <v-btn
            style="width: 190px"
            color="#3cc0c9"
            class="btn-rounded-medium ml-2"
            to="/giveovations"
            small
          >
            <img
              class="mr-2 ml-3"
              src="https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/Ovation-260-260.png"
              alt="Send Ovations"
              style="width: 20px"
            /><span class="pr-4 font-weight-bold white--text"
              >Send Ovations</span
            >
          </v-btn>
          <v-btn
            style="width: 190px"
            v-if="$store.getters.allowGivingNoOvations"
            color="#EEE34D"
            class="btn-rounded-medium"
            to="/sendkudos"
            small
            ><span class="mx-3">Send Kudos!</span></v-btn
          >
          <v-btn
            style="width: 190px"
            v-if="
              $store.getters.userIsAdministrativeOrOrgOwner &&
              !$store.getters.isCurrentOrgChild
            "
            color="#d13b55"
            class="btn-rounded-medium"
            to="/assignovations"
            dark
            small
          >
            <img
              class="mr-2 ml-3"
              src="https://s3.us-east-2.amazonaws.com/s3-img.giveovation.com/Ovation-260-260.png"
              alt="Distribute Ovations"
              style="width: 20px"
            /><span class="pr-4 font-weight-bold">DISTRIBUTE OVATIONS</span>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: "SendOvationsCard",
};
</script>

<style></style>
